<div class="delimeter"></div>
<div class="alerts-notifications component">
  <h2 class="header">Alerts</h2>
  <div class="delimeter"></div>
  @if ((alertList$ | async)?.length) { @for (alert of alertList$ | async; track
  alert) {
  <div class="alert-wrapper">
    <div class="alert-notification-row">
      <div class="notification-name-icon">
        @if (alert.isInApp) {
        <mat-icon color="primary" class="notification-icon"
          >notifications</mat-icon
        >
        }
        <a class="notification-name" (click)="openAlert(alert)">{{
          alert.displayName
        }}</a>
      </div>
      <div class="date-wrapper">
        <p class="notification-date">
          {{
            alert?.updateTime?.toString()
              | dateWithTimezone : 'MMM dd, yyyy h:mm a'
          }}
        </p>
      </div>
    </div>
  </div>
  } } @else {
  <p class="empty-alerts-notifications">No Active Alerts</p>
  }
  <h2 class="header">Notifications</h2>
  <div class="delimeter"></div>
  @if ((notificationList$ | async)?.length) {
  <div class="notification-wrapper">
    @for (notification of notificationList$ | async; track notification) {
    <div style="display: flex; flex-direction: column">
      <div class="alert-notification-row">
        <div class="notification-name-icon">
          @if (notification.isInApp) {
          <mat-icon color="primary" class="notification-icon"
            >notifications</mat-icon
          >
          }
          <a
            class="notification-name"
            [ngClass]="{ 'no-link': !notification.linkUrl }"
            (click)="openPage(notification.linkUrl)"
            >{{ notification.displayText }}</a
          >
        </div>
        <div class="date-wrapper">
          <p class="notification-date">
            {{
              notification?.eventTime?.toString()
                | dateWithTimezone : 'MMM dd, yyyy h:mm a'
            }}
          </p>
        </div>
      </div>
    </div>
    }
  </div>
  } @else {
  <p class="empty-alerts-notifications">No Active Notifications</p>
  }
</div>
